import { connect } from "react-redux";
import WalletApproval from './WalletApproval';
import { bindActionCreators } from "redux";
import {requestApprovalList} from "../../../services/redux/Wallet/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    approvalListDetails : state.Wallet.approvlListData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        requestApprovalList,
        documentUploadUrl
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WalletApproval);